export const FormType = Object.freeze({
  CREATE: "Create",
  VIEW: "View"
});
